import React from 'react';
import PropTypes from 'prop-types';
import HereDomMarker from 'shared/hereMap/HereDomMarker';

const iconCache = {};

function HerePolygonMarker({ position, index, hideOnDrag, draggable, resizable, onChange, onClick, middlePoint, type, cursorStyle, icon, zIndex, length = 1 }) {
  const basicColor = type === 'polygonMarker' ? 'lightblue' : 'white';
  const pointColor = (draggable || resizable) ? basicColor : 'gray';
  const newIndex = length > 50 ? '' : index;

  if (!icon) {
    const key = middlePoint ? (basicColor + 'middle'): (newIndex + pointColor + index);
    if (iconCache[key]) {
      icon = iconCache[key];
    } else {
      const pointIcon = '<svg width="12" height="12" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
        '<style>.small {font-size: 10px;}</style>' +
        '<rect width="12" height="12" fill="'+pointColor+'" stroke="black" stroke-width="1"/>' +
        '<text x="6" y="10" class="small" text-anchor="middle">'+newIndex+'</text>'+
        '</svg>';
      const middlePointIcon = '<svg width="12" height="12" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
        '<circle cx="6" cy="6" r="5" fill="'+basicColor+'" stroke="black" stroke-width="1"/>' +
        '</svg>';
      const newIcon = new window.H.map.Icon(
        middlePoint ? middlePointIcon : pointIcon, {anchor: {x: 6, y: 6}}
      );
      iconCache[key] = newIcon;
      icon = newIcon;
    }
  }
  const data = {hideOnDrag};
  return <HereDomMarker 
    latLng={position} 
    options={{ icon, data, zIndex }} 
    draggable={draggable} 
    resizable={resizable} 
    onChange={onChange} 
    onClick={onClick}
    cursorStyle={cursorStyle}
  />;
}

HerePolygonMarker.propTypes = {
  position: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default HerePolygonMarker;
